import { stats } from '@/mocks/content';

const heroCards = [
  {
    id: 1,
    title: '本周首推：《城中村的清晨》完整版',
    creator: '阿良的日常',
    duration: '08:24',
    views: '128.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20warm%20variety%20show%20stage%20with%20golden%20stage%20lights%20and%20a%20glowing%20screen%2C%20rich%20amber%20and%20orange%20atmosphere%2C%20premium%20entertainment%20photography%2C%20dramatic%20and%20clean&width=900&height=560&seq=dv-hero-01&orientation=landscape',
  },
  {
    id: 2,
    title: '深夜音乐电台精选',
    creator: '晚风Radio',
    duration: '05:12',
    views: '96.4万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20night%20music%20studio%20with%20a%20microphone%20and%20a%20glowing%20lamp%2C%20soft%20golden%20bokeh%20lights%20in%20background%2C%20cinematic%20mood%2C%20warm%20amber%20tones&width=500&height=320&seq=dv-hero-02&orientation=landscape',
  },
  {
    id: 3,
    title: '十分钟家常菜教程',
    creator: '小满厨房',
    duration: '06:47',
    views: '88.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Hands%20cooking%20a%20fresh%20home%20dish%20in%20a%20warm%20sunlit%20kitchen%2C%20steam%20and%20golden%20light%2C%20cozy%20food%20photography%2C%20rich%20warm%20tones&width=500&height=320&seq=dv-hero-03&orientation=landscape',
  },
];

export default function Hero() {
  return (
    <section id="top" className="relative pt-24 md:pt-28 pb-12 md:pb-16 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-background-100 via-background-50 to-background-50" />
      <div className="absolute -top-16 -left-24 -z-10 w-80 h-80 rounded-full bg-accent-200/50 blur-3xl" />
      <div className="absolute top-32 right-0 -z-10 w-96 h-96 rounded-full bg-primary-100/60 blur-3xl" />

      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-5 flex flex-col gap-5 md:gap-6 dv-reveal">
            <span className="inline-flex w-fit items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3.5 py-1.5 text-xs font-medium text-accent-900">
              <i className="ri-fire-line text-accent-700" />
              每日整理 · 热门推荐 / 主播 / 无删减合集
            </span>

            <h1 className="font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              榴莲视频在线观看指南
              <span className="mt-2 block text-xl md:text-2xl font-bold text-primary-700">
                福利主播、短视频热门推荐与无删减内容一网打尽
              </span>
            </h1>

            <p className="text-sm md:text-base leading-relaxed text-foreground-700 max-w-xl">
              这里把<strong className="font-semibold text-foreground-900">热门推荐</strong>、
              <strong className="font-semibold text-foreground-900">福利主播</strong>与
              <strong className="font-semibold text-foreground-900">无删减合集</strong>
              集中整理成一份可浏览的内容地图，帮你快速发现感兴趣的作品，也方便到社区里参与讨论。
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                浏览热门推荐
              </a>
              <a
                href="#streamers"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-secondary-300 bg-secondary-50 px-5 py-3 text-sm font-semibold text-secondary-900 whitespace-nowrap transition-colors hover:bg-secondary-100 cursor-pointer"
              >
                <i className="ri-user-voice-line text-lg" />
                查看福利主播榜
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-3 pt-1">
              {stats.slice(0, 3).map((item) => (
                <div key={item.id} className="flex items-center gap-2">
                  <i className={`${item.icon} text-primary-600`} />
                  <span className="font-heading text-lg font-bold text-foreground-950">{item.value}</span>
                  <span className="text-xs text-foreground-600">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 dv-reveal">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <article className="col-span-2 group relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="relative w-full h-[220px] md:h-[300px]">
                  <img
                    src={heroCards[0].cover}
                    alt="榴莲视频热门推荐封面：城中村的清晨完整版"
                    title="城中村的清晨 热门推荐"
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                    <i className="ri-fire-line" /> 本周首推
                  </span>
                  <span className="absolute bottom-3 right-3 rounded bg-black/60 px-2 py-0.5 text-[11px] text-white">
                    {heroCards[0].duration}
                  </span>
                  <div className="absolute bottom-3 left-3 right-16 text-left">
                    <p className="text-sm md:text-base font-semibold text-white line-clamp-1">
                      {heroCards[0].title}
                    </p>
                    <p className="mt-1 text-[11px] md:text-xs text-white/80">
                      {heroCards[0].creator} · {heroCards[0].views} 次观看
                    </p>
                  </div>
                </div>
              </article>

              {heroCards.slice(1).map((card) => (
                <article key={card.id} className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <div className="relative w-full h-[120px] md:h-[150px]">
                    <img
                      src={card.cover}
                      alt={`${card.title} 视频封面`}
                      title={`${card.title} 短视频`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                    <span className="absolute bottom-2 right-2 rounded bg-black/60 px-1.5 py-0.5 text-[10px] text-white">
                      {card.duration}
                    </span>
                    <div className="absolute bottom-2 left-2 right-12 text-left">
                      <p className="text-xs font-semibold text-white line-clamp-1">{card.title}</p>
                      <p className="text-[10px] text-white/80">{card.creator}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}